import { Step } from '@/components/atoms/step'
import React from 'react'
import { useTranslation } from 'react-i18next'

/**
 * 番号ではなく名前で指定する。番号だと、間に本人確認のページを挟んだときに
 * 後続のページが誤って「本人確認」の位置を指してしまう事故が起きやすいため。
 */
export const CheckInStepName = {
  ReservationSearch: 0,
  Login: 1,
  GuestInformation: 2,
  Confirmation: 3,
} as const
export type CheckInStepName = (typeof CheckInStepName)[keyof typeof CheckInStepName]

type Props = {
  current: CheckInStepName
}

export const CheckInStep: React.FC<Props> = props => {
  const { t } = useTranslation()

  return (
    <Step
      items={[t('Search scheduled reservation'), t('Login / Sign up'), t('Enter guest information'), t('Check and Payment')]}
      {...props}
    />
  )
}
